import { render, staticRenderFns } from "./VisualizarArquivos.vue?vue&type=template&id=3a628985&"
import script from "./VisualizarArquivos.vue?vue&type=script&lang=js&"
export * from "./VisualizarArquivos.vue?vue&type=script&lang=js&"
import style0 from "./VisualizarArquivos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports